import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import "./AddEventModal.css";
import Select from "react-select";
import apiServiceHandler from "../../service/apiService";
import "toastr/build/toastr.min.css";
import toastr from "toastr";

const groupOptions = [
  { value: "stg90", label: "STG Group" },
  { value: "boa", label: "Lab Group" },
  { value: "club84", label: "CCA Group" },
];

const repeatOptions = [
  { value: "once", label: "Once" },
  { value: "daily", label: "Daily" },
  { value: "weekly", label: "Weekly" },
  { value: "biweekly", label: "Bi-Weekly" },
];

const durationOptions = [
  { value: 30, label: "30 minutes" },
  { value: 60, label: "1 hour" },
  { value: 90, label: "1 hour 30 minutes" },
  { value: 120, label: "2 hours" },
  { value: "custom", label: "Custom" },
];

const customStyles = {
  control: (provided, state) => ({
    ...provided,
    boxShadow: 'none',
    border: state.isFocused ? '1px solid #ccc' : '1px solid #ddd',
    outline: 'none',
    '&:hover': {
      border: '1px solid #aaa',
    },
  })
};

const AddEventModal = ({ isOpen, onClose, setRefreshEventData }) => {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [meetingURL, setMeetingURL] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [repeatSelectedOption, setRepeatSelectedOption] = useState(null);
  const [groupSelectedOption, setGroupSelectedOption] = useState(null);
  const [durationSelectedOption, setDurationSelectedOption] = useState(null);
  const [showCustomEndDate, setShowCustomEndDate] = useState(false);

  const handleDurationChange = (option) => {
    setDurationSelectedOption(option);
    if (option.value === "custom") {
      setShowCustomEndDate(true);
      setEndDate("");
    } else {
      setShowCustomEndDate(false);
      if (startDate) {
        const startDateTime = new Date(startDate);
        const calculatedEndDate = new Date(startDateTime.getTime() + option.value * 60000);
        setEndDate(calculatedEndDate);
      }
    }
  };

  const sendAddEvent = async () => {
    try {
      if (!(title && startDate && endDate && repeatSelectedOption && groupSelectedOption)) {
        toastr.error("Please fill in all fields");
        throw new Error("Please fill in all fields")
      }
      const payload = {
        title: title,
        description: description,
        meeting_url: meetingURL,
        start: new Date(startDate).toUTCString(),
        end: new Date(endDate).toUTCString(),
        repeat: repeatSelectedOption.value,
        group_code: groupSelectedOption.value
      }
      const response = await apiServiceHandler("POST", "api/calendar/events", { ...payload });
      if (response.auth) {
        toastr.success(response.message);
        setTitle("");
        setDescription("");
        setMeetingURL("");
        setStartDate("");
        setEndDate("");
        setRepeatSelectedOption(null);
        setGroupSelectedOption(null);
        setDurationSelectedOption(null);
        setRefreshEventData(true);
        onClose();
      } else {
        toastr.error(response.message || "Failed to add Event. Please try again.");
      }
    } catch (error) {
      toastr.error(error?.response?.data?.message);
      console.error(error?.response);
    }
  };

  return (
    <Modal show={isOpen} onHide={onClose} centered>
      <Modal.Header closeButton style={{ borderBottom: "none" }}>
        <Modal.Title>Add Event</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="invite-form__fields">
          <div className="invite-form__field">
            <div className="text-input__label">Title</div>
            <div className="form-input__wrapper">
              <input
                type="text"
                className="form-input__input"
                required
                value={title}
                onChange={(e) => setTitle(e.target.value)} />
            </div>
          </div>
          <div className="invite-form__field">
            <div className="text-input__label">Description</div>
            <div className="form-input__wrapper">
              <input
                type="text"
                className="form-input__input"
                required
                value={description}
                onChange={(e) => setDescription(e.target.value)} />
            </div>
          </div>
          <div className="invite-form__field">
            <div className="text-input__label">Meeting Link</div>
            <div className="form-input__wrapper">
              <input
                type="text"
                className="form-input__input"
                required
                value={meetingURL}
                onChange={(e) => setMeetingURL(e.target.value)} />
            </div>
          </div>
          <div className="invite-form__field">
            <div className="text-input__label">Start Date</div>
            <div className="form-input__wrapper">
              <input
                type="datetime-local"
                className="form-input__input"
                required
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
              />
            </div>
          </div>
          <div className="select-invite-form__field">
            <div className="select__label">Duration</div>
            <Select
              defaultValue={durationSelectedOption}
              onChange={handleDurationChange}
              options={durationOptions}
              placeholder=""
              styles={customStyles}
            />
          </div>
          {showCustomEndDate && <div className="invite-form__field">
            <div className="text-input__label">End Date</div>
            <div className="form-input__wrapper">
              <input
                type="datetime-local"
                className="form-input__input"
                required
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
              />
            </div>
          </div>}
          <div className="select-invite-form__field">
            <div class="select__label">Repeat</div>
            <Select
              defaultValue={repeatSelectedOption}
              onChange={setRepeatSelectedOption}
              options={repeatOptions}
              placeholder=""
              styles={customStyles}
            />
          </div>
          <div className="select-invite-form__field">
            <div class="select__label">Select Group</div>
            <Select
              defaultValue={groupSelectedOption}
              onChange={setGroupSelectedOption}
              options={groupOptions}
              placeholder=""
              styles={customStyles}
            />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer style={{ borderTop: "none", paddingTop: '1rem' }}>
        <button className="send-invite__btn" onClick={sendAddEvent}>
          <span className="send-invite-button__label">Add Event</span>
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default AddEventModal;
